<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title">Agregar o Editar una Giftcard</h4>
        <button type="button" class="close" (click)="cancel()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="productForm" (ngSubmit)="productForm.valid && confirm()">
        <div class="modal-body">
            <div class="form-group row">
                <label class="col-2 col-form-label"><b>Giftcard</b>
                    <span appRequiredAsterisk [formGroup]="productForm" controlName="giftcardNumber"></span>
                </label>
                <div class="col-10 ">
                    <input type="number" class="form-control" formControlName="giftcardNumber"
                        (keypress)="onlyIntegerNumbers($event)"
                        [ngClass]="productForm.controls.giftcardNumber.errors ? 'is-invalid' : 'is-valid'">
                </div>
            </div>
            <div class="form-group row">
                <label class="col-2 col-form-label"><b>Monto</b>
                    <span appRequiredAsterisk [formGroup]="productForm" controlName="amount"></span>
                </label>
                <div class="col-10 ">
                    <input type="text" mask="separator.2" thousandSeparator="," class="form-control"
                        formControlName="amount"
                        [ngClass]="productForm.controls.amount.errors ? 'is-invalid' : 'is-valid'">
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancelar</button>
            <button type="submit" class="btn btn-outline-success">Confirmar</button>
        </div>
    </form>

</div>